import { call, put, takeLatest } from "redux-saga/effects";
import * as dashboardApis from "../apis/dashboardApis"
import { DASHBOARD, DASHBOARD_MONTHLY_SALES } from "../actions/types";

export function* dashboardWorker(action) {
    try {
        const res = yield call(dashboardApis.dashboardApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* dashboardMonthlySalesWorker(action) {
    try {
        const res = yield call(dashboardApis.dashboardMonthlySalesApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* dashboardWatcher() {
    yield takeLatest(DASHBOARD, dashboardWorker);
}

export function* dashboardMonthlySalesWatcher() {
    yield takeLatest(DASHBOARD_MONTHLY_SALES, dashboardMonthlySalesWorker);
}